<template>
  <PageBreadcrumbs :items="breadcrumbs" data-testid="agency-edit-breadcrumb" />
  <AgencyCompletion :agency="agency" />
  <RouterView :agency="agency" />
</template>
<script setup lang="ts">
import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { AgencyCompletion } from '@/components/ProfileCompletion'
import { useReviewsAgencyBreadcrumbs } from '@/composables/breadcrumbs/useReviewsAgencyBreadcrumbs'
import type { AgencyData } from '@/gql/reviews'
const props = defineProps<{
  agency: AgencyData
}>()

const breadcrumbs = useReviewsAgencyBreadcrumbs(props.agency)
</script>
